import React from 'react';
import { Logo, LogoVariant, LogoSize } from './Logo';
import { useTheme } from '../../contexts/ThemeContext';

interface ThemeAwareLogoProps {
  size?: LogoSize;
  className?: string;
  showText?: boolean;
  textClassName?: string;
  forceVariant?: LogoVariant;
}

export const ThemeAwareLogo: React.FC<ThemeAwareLogoProps> = ({ 
  size = 'md', 
  className = '',
  showText = true,
  textClassName = '',
  forceVariant
}) => {
  const { isDarkMode } = useTheme();

  // Determine the best logo variant based on context
  const getVariant = (): LogoVariant => {
    if (forceVariant) return forceVariant;
    
    // Check if we're on a dark background
    const hasDarkBackground = className.includes('bg-gray-900') || 
                             className.includes('bg-black') || 
                             className.includes('bg-indigo-900');
    
    if (isDarkMode || hasDarkBackground) {
      return 'white';
    }
    
    return 'color';
  };

  return (
    <Logo 
      variant={getVariant()}
      size={size}
      className={className}
      showText={showText}
      textClassName={textClassName}
    />
  );
};

// Specialized logo components for different contexts
export const HeaderLogo: React.FC<Omit<ThemeAwareLogoProps, 'forceVariant'>> = (props) => (
  <ThemeAwareLogo {...props} />
);

export const SidebarLogo: React.FC<Omit<ThemeAwareLogoProps, 'forceVariant'>> = (props) => (
  <ThemeAwareLogo {...props} />
);

export const FooterLogo: React.FC<Omit<ThemeAwareLogoProps, 'forceVariant'>> = (props) => (
  <ThemeAwareLogo {...props} forceVariant="white" />
);

export const AuthPageLogo: React.FC<Omit<ThemeAwareLogoProps, 'forceVariant'>> = (props) => (
  <ThemeAwareLogo {...props} size="lg" />
);
